"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateBasketItemHandler = updateBasketItemHandler;
var _updateBasketItemFailed = require("@ori-events/update-basket-item-failed");
var _types = require("../types");
var _utils = require("../utils");
async function updateBasketItemHandler({
  detail: {
    lineNumber,
    placement,
    quantity
  }
}) {
  const response = await fetch(`${_types.RequestUrl.UpdateBasketItem}?lineNumber=${lineNumber}&quantity=${quantity}`, (0, _utils.getHttpRequestSettings)({
    placement
  }));
  const data = (0, _utils.convertToCamelCase)(await response.json());
  if ((0, _updateBasketItemFailed.isUpdateBasketItemErrorResponse)(data)) {
    const errorEvent = new CustomEvent(_updateBasketItemFailed.Name, {
      detail: data
    });
    window.dispatchEvent(errorEvent);
    return false;
  }
  return data;
}